// components/Footer.js
import { Box, Typography, Link } from '@mui/material';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto',
        py: 2,
        px: 3,
        background: 'linear-gradient(to left, #004e92, #000428)',
        color: '#fff',
        textAlign: 'center',
        fontFamily: 'Cairo, sans-serif',
        direction: 'rtl'
      }}
    >
      <Typography variant="body2" sx={{ mb: 1 }}>
        <Link href="#" underline="hover" sx={{ color: '#fff', mx: 1 }}>
          About
        </Link>
        |
        <Link href="#" underline="hover" sx={{ color: '#fff', mx: 1 }}>
          Contact Us
        </Link>
        |
        <Link href="#" underline="hover" sx={{ color: '#fff', mx: 1 }}>
          Privacy
        </Link>
      </Typography>
      <Typography variant="caption" sx={{ opacity: 0.8 }}>
        All rights reserved © {new Date().getFullYear()}
      </Typography>
    </Box>
  );
};

export default Footer;
